import { selectStyle } from 'Shared/forms/Inputs'
import { labelOnLeftStyle, labelStyle } from 'Shared/forms/Wrap'
import { Match, Switch } from 'solid-js';
import { useStore } from 'Shared/StoreProvider';
import { dbPatchField } from 'Shared/forms/BaseOperations';
import { verticalStyle } from 'Shared/backend/Theme';
import { Show } from 'solid-js';


interface ISides {
	label:string;
	property:string;
//	settings: ({label:string,path:Location}) => JSX.Component;
	settings;
	defaults;
	sides;
	style;
}


export function Sides(P:ISides)
{
	const sw = useStore();

	const Settings = P.settings;

	const changeSides = async e => {
		const value = e.target.value;
		let content = {sides:value};

		if (value=='all')
			content = {...content,all:P.defaults()};
		else if (value=='opposites')
			content = {...content,vertical:P.defaults(),horizontal:P.defaults()};
		else if (value=='different')
			content = {...content,top:P.defaults(),bottom:P.defaults(),left:P.defaults(),right:P.defaults()};

		await dbPatchField(sw,P.property,content);
	};

	return (
		<div class={verticalStyle()}>
			<div class={labelOnLeftStyle()}>
				<Show when={P.label}>
					<label for={P.property} class={labelStyle()}>{P.label}</label>
				</Show>

				<select id={P.property} class={selectStyle()} onChange={changeSides} onClick={e => e.stopPropagation()}>
					<option value='all' selected={P.sides=='all'}>All sides same</option>
					<option value='opposites' selected={P.sides=='opposites'}>Opposite sides the same</option>
					<option value='different' selected={P.sides=='different'}>Different settings for each side</option>
				</select>
			</div>

			<Show when={P.sides}>
				<div class={P.style}>
					<Switch>
						<Match when={P.sides == 'all'}>
							<Settings label='All sides' name='all' />
						</Match>
						<Match when={P.sides == 'opposites'}>
							<Settings label='Top & Bottom' name='vertical' />
							<Settings label='Left & Right' name='horizontal' />
						</Match>
						<Match when={P.sides == 'different'}>
							<Settings label='Top' name='top' />
							<Settings label='Bottom' name='bottom' />
							<Settings label='Left' name='left' />
							<Settings label='Right' name='right' />
						</Match>
					</Switch>
				</div>
			</Show>
		</div>
	);
}

